import arcadeDecorations from './arcade'
import coProducerDecorations from './co-producer'
import creatorDecorations from './creator'
import portalDecorations from './portal'
import shiftDecorations from './shift'
import thermalDecorations from './thermal'
import movementDecorations from './movement'

export default [arcadeDecorations, coProducerDecorations, creatorDecorations, portalDecorations, shiftDecorations, thermalDecorations, movementDecorations]
